import { Identifiers, SectionsKey } from '~/constants/enum';

const PageStruct = {
    id: 'home',
    useLayout: true,
    children: [
        { id: SectionsKey.Hero, order: 1, identifier: Identifiers.Hero },
        { id: SectionsKey.CategoriesSection, order: 2, identifier: Identifiers.CategoriesSection },
        { id: SectionsKey.Introduction, order: 3, identifier: Identifiers.Introduction },
        { id: SectionsKey.FeaturedProductV2, order: 4, identifier: Identifiers.FeaturedProductV2 },
        { id: SectionsKey.FirstBanner, order: 5, identifier: Identifiers.FirstBanner },
        { id: SectionsKey.Cards, order: 6, identifier: Identifiers.Cards },
        { id: SectionsKey.FeaturedProductV2, order: 7, identifier: Identifiers.FeaturedProductV2_2 },
        { id: SectionsKey.NewCollections, order: 8, identifier: Identifiers.NewCollection },
        { id: SectionsKey.SecondBanner, order: 9, identifier: Identifiers.SecondBanner },
        { id: SectionsKey.FeaturedProductV2, order: 10, identifier: Identifiers.FeaturedProductV2_3 },
        { id: SectionsKey.Artist, order: 11, identifier: Identifiers.Artist },
        { id: SectionsKey.ThirdBanner, order: 12, identifier: Identifiers.ThirdBanner },
        { id: SectionsKey.Organization, order: 13, identifier: Identifiers.Organization },
        { id: SectionsKey.HomePageReviews, order: 14, identifier: Identifiers.HomePageReviews },
        { id: SectionsKey.BenefitsSection, order: 15, identifier: Identifiers.BenefitsSection },
        { id: SectionsKey.FollowUs, order: 16, identifier: Identifiers.FollowUs }
    ]
};

export default PageStruct;
